export enum Permission {
  ROLE_SALE_MANAGER = 'ROLE_SALE_MANAGER',
  ROLE_SALER = 'ROLE_SALER',
  ROLE_SALE_SHG = 'ROLE_SALE_SHG',
}

const usePermission = () => {};

export default usePermission;
